import { render } from "./FontFamily.vue?vue&type=template&id=2c009b3b&scoped=true"
import script from "./FontFamily.vue?vue&type=script&lang=ts"
export * from "./FontFamily.vue?vue&type=script&lang=ts"

import "./FontFamily.vue?vue&type=style&index=0&id=2c009b3b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2c009b3b"

export default script